import React from 'react';
import Select from 'components/UI/V3/Forms/Select';
import styles from './MinNightsSection.module.scss';

interface MinNightsSectionProps {
    value: number;
    onChange: (value: number) => void;
    error?: string;
}

export const MinNightsSection: React.FC<MinNightsSectionProps> = ({ value, onChange, error }) => {
    const minNightsOptions = Array.from({ length: 30 }, (_, i) => ({
        value: (i + 1).toString(),
        label: `${i + 1}`
    }));

    const handleChange = (optionValue: string) => {
        onChange(parseInt(optionValue, 10));
    };

    return (
        <div className={styles.container}>
            <h3 className={styles.title}>
                Min Nights <span className={styles.required}>*</span>
            </h3>
            <p className={styles.description}>Set the minimum number of nights required to make a booking.</p>

            <Select
                className={styles.select}
                value={value.toString()}
                options={minNightsOptions}
                onChange={handleChange}
                error={error}
            />
        </div>
    );
};
